import React, { useEffect, useState } from 'react'
import { Container, Grid } from '@mui/material'

import './LiveTips.scss'
import Tips from '../components/tips'
import Fixtures from '../components/fixtures'
import { useAppDispatch, useAppSelector } from '../redux'
import { changeActiveTab, getFixtures } from '../redux/slices/fixtures'
import GameDetails from '../components/game-details'
import { FETCH_INTERVAL, isDesktopWindow, isTabletWindow } from '../utils'

export default function LiveTips() {
    const dispatch = useAppDispatch()
    const { competitions, activeTab } = useAppSelector((state) => state.fixtures)
    const { activePage } = useAppSelector((state) => state.settings)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [liveTipsComponentWidth, setLiveTipsComponentWidth] = useState(
        document.getElementsByClassName('live-tips-component')[0]?.clientWidth
    )

    const { activeGame } = useAppSelector((state) => state.fixtures)
    const activeGameId = activeGame?.id

    const handleChangeTab = (tabId: any) => {
        dispatch(changeActiveTab(tabId))

        if (tabId === 'all') {
            dispatch(getFixtures())
        }
    }
    const getActiveTab = (tab = 'all') => (activeTab === tab ? 'active' : '')

    const isDesktopMode = isDesktopWindow(windowWidth)
    const isTabletMode = isTabletWindow(windowWidth)

    let inProgressCount = 0
    competitions.forEach((tournament) => {
        tournament.games.forEach((game) => {
            if (game.status.type === 'inprogress') {
                inProgressCount++
            }
        })
    })

    const isLiveTab = activeTab === 'live'
    let filteredCompetitions = competitions.reduce((acc: any, competition: any) => {
        if (isLiveTab) {
            const liveGames = competition.games
                .filter((game: any) => game.status.type === 'inprogress')
                .map((game: any) => ({
                    ...game,
                    live: true,
                }))
            if (liveGames.length) {
                acc.push({
                    ...competition,
                    games: liveGames,
                })
            }
        } else {
            acc.push(competition)
        }

        return acc
    }, [])

    useEffect(() => {
        handleChangeTab(activeTab)
        // Function to handle window resize event
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
            setLiveTipsComponentWidth(
                document.getElementsByClassName('live-tips-component')[0]?.clientWidth
            )
        }

        // Add event listener for window resize
        window.addEventListener('resize', handleResize)

        // Function to handle visibility change
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                // The page has become visible, refresh your content
                dispatch(getFixtures())
            }
        }

        // Add event listener for visibility change
        document.addEventListener('visibilitychange', handleVisibilityChange)

        dispatch(getFixtures())

        // Set up interval to fetch fixtures periodically
        window['get_fixtures_interval'] = setInterval(() => {
            dispatch(getFixtures())
        }, FETCH_INTERVAL)

        // Clean up the event listeners and intervals on component unmount
        return () => {
            window.removeEventListener('resize', handleResize)
            document.removeEventListener('visibilitychange', handleVisibilityChange)
            if (window['get_fixtures_interval']) {
                clearInterval(window['get_fixtures_interval'])
            }
        }
    }, []) // Empty dependency array to run the effect only once

    return (
        <Container
            maxWidth={false}
            style={{
                paddingLeft: 0,
                paddingRight: 0,
            }}
        >
            <Grid className="live-tips-container">
                <Grid container style={{ padding: 0, gap: 6 }}>
                    <Grid
                        className="fixtures-component"
                        item
                        style={{
                            display:
                                (activePage === 'Live' && !activeGameId) ||
                                isDesktopMode ||
                                (isTabletMode && !activeGameId)
                                    ? 'block'
                                    : 'none',
                        }}
                    >
                        <div className="tabs">
                            <div
                                className={'card-shadow tab-item ' + getActiveTab('all')}
                                onClick={() => handleChangeTab('all')}
                            >
                                All
                            </div>
                            <div
                                className={'card-shadow tab-item ' + getActiveTab('live')}
                                onClick={() => handleChangeTab('live')}
                            >
                                Live ({inProgressCount})
                            </div>
                        </div>

                        <Fixtures competitions={filteredCompetitions} />
                    </Grid>
                    <Grid
                        className="game-details-component"
                        item
                        style={{
                            maxWidth: isDesktopMode
                                ? 'calc(100% - 652px)'
                                : isTabletMode
                                    ? `calc(100% - ${liveTipsComponentWidth + 15}px)`
                                    : 'none',
                            flex: 1,
                            display: activeGameId || isDesktopMode ? 'block' : 'none',
                        }}
                    >
                        <GameDetails />
                    </Grid>
                    <Grid
                        className="live-tips-component"
                        item
                        style={{
                            display:
                                (activePage === 'Tips' && !activeGameId) ||
                                isDesktopMode ||
                                isTabletMode
                                    ? 'block'
                                    : 'none',
                        }}
                    >
                        <Tips />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}
